import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import { styled } from '@zenbusiness/zui/styles';

const FormControlLabelStyles = () => ({
  '& .MuiRadio-root': {
    alignSelf: 'flex-start',
    paddingTop: '4px'
  }
});

export const FormControlLabelStyled = styled(FormControlLabel)(FormControlLabelStyles);
